import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import "./index.css";

const root = createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <AuthProvider>
                <Toaster
                    position="top-center"
                    toastOptions={{
                        loading: { duration: Infinity },
                        style: {
                            background: '#fff',
                            color: '#374151',
                            boxShadow: '0 4px 24px rgba(0, 0, 0, 0.15)',
                            borderRadius: '12px',
                            padding: '12px 16px',
                        },
                    }}
                />
                <App />
            </AuthProvider>
        </BrowserRouter>
    </React.StrictMode>
);
